import { render, staticRenderFns } from "./ShipMentsModal.vue?vue&type=template&id=3fb216d8&scoped=true"
import script from "./ShipMentsModal.vue?vue&type=script&lang=js"
export * from "./ShipMentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb216d8",
  null
  
)

export default component.exports